export const PASSENGER_FORCE_UPDATE_MIN_BUILD_KEY = 'passenger_force_update_min_build';
export const DRIVER_FORCE_UPDATE_MIN_BUILD_KEY = 'driver_force_update_min_build';

/** 0 或留空 = 關閉強更 */
export function parseForceUpdateMinBuild(raw: string | null | undefined): number {
  const t = String(raw ?? '').trim();
  if (!t) return 0;
  const n = parseInt(t, 10);
  if (!Number.isFinite(n) || n < 0) return 0;
  return n;
}

export function isForceUpdateRequired(currentBuild: number, minBuild: number): boolean {
  if (minBuild <= 0) return false;
  if (!Number.isFinite(currentBuild) || currentBuild <= 0) return true;
  return currentBuild < minBuild;
}

export const DEFAULT_FORCE_UPDATE_MESSAGE_ZH =
  '此 App 版本過舊，請更新至最新版本後才能繼續使用。';
